import { createContext, FC, PropsWithChildren, useContext, useEffect, useMemo, useState } from 'react'

import Api from '../utils/api'

import { AuthenticationContext } from './auth-provider'

interface IFolderTreeContext {
  folderTree: IFolderTreeResponse | null
  error: boolean
}

export const FolderTreeContext = createContext<IFolderTreeContext>({ folderTree: null, error: false })

// Loads the folder tree once per login so every consumer shares a single request
const FolderTreeProvider: FC<PropsWithChildren> = ({ children }) => {
  const { ownUser } = useContext(AuthenticationContext)
  const isLoggedIn = !!ownUser
  const [folderTree, setFolderTree] = useState<IFolderTreeResponse | null>(null)
  const [error, setError] = useState<boolean>(false)

  useEffect(() => {
    if (!isLoggedIn) {
      setFolderTree(null)
      setError(false)
      return
    }

    const getFolderTree = async () => {
      try {
        const res = await Api.get('/api/folders/tree')
        if (res.ok) {
          setFolderTree(res.body as IFolderTreeResponse)
          setError(false)
        } else {
          setError(true)
        }
      } catch {
        setError(true)
      }
    }

    getFolderTree()
  }, [isLoggedIn])

  const value = useMemo(() => ({ folderTree, error }), [folderTree, error])

  return <FolderTreeContext.Provider value={value}>{children}</FolderTreeContext.Provider>
}

export default FolderTreeProvider
